<template>
    <div>
       <Modal
           class-name="vertical-center-modal"
           :value="showSetModel"
           :title="title"
           :footer-hide="true"
           :mask-closable="false"
           @on-cancel="cancel"
           @on-visible-change="openOrClose"  :styles="{'min-width':'860px','max-height':'800px'}">
           
           <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80"  inline>
               <Tabs type="card" v-model="currentTab">
                  <TabPane label="基础信息" name="tab1">
                        <!-- 字段identifier是hyeco实现方式的指令标识，在创建lora指令的时候可以不用管他-->
                       <FormItem  :label="$t('BasicProduct.funcBox.titleName.Identifier')" prop="keyId" :class="'ivu-form-item-required'" style="width: 400px">
                           <Input type="text" v-model="formData.keyId" :placeholder="$t('inputPlaceholder')" :disabled="type==2 || isGener"></Input>
                       </FormItem>

                       <!-- 功能名称 -->
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.IndentyName')" prop="keyNameLanguageKey" class="ivu-form-item-required" style="width: 400px">
                           
                           <SearchSelectRecycle refName="keyNameRef" listName="dealersList"  ref="keyNameRef" :selectUrlQuery="{pageId:pageID,page:1,limit:20000}" :url="pagesLangDictionaryListUrl" labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'keyName')"></SearchSelectRecycle>
                       </FormItem>
             
                     
                      
                       <!-- 只有16进制需要字节长度 -->
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.Bytes')" prop="hexValueBytes" v-if="(designImplTypeNum==2 || designImplTypeNum==-1) && keyType!=8" :rules="[{ required:true, message:$t('required'), trigger:'blur' }]" style="width: 400px" >
                           <Input type="number" v-model.trim="formData.hexValueBytes" :placeholder="$t('inputPlaceholder')"  :disabled="isGener"></Input>
                       </FormItem>
                       
                       <!-- 功能描述 -->
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.Discription')" prop="descrLanguageKey" class="" style="width: 400px">
                         

                           <!-- <SearchSelectPage refName="descrRef" listName="dealersList" :showPage="true" ref="descrRef" :selectUrlQuery="{pageId:pageID}" :url="pagesLangDictionaryListUrl" labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'descr')"></SearchSelectPage> -->
                           <SearchSelectRecycle refName="descrRef" listName="dealersList" :showPage="true" ref="descrRef" :selectUrlQuery="{pageId:pageID}" :url="pagesLangDictionaryListUrl" labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNew($event,'descr')"></SearchSelectRecycle>

                       </FormItem>





                       <FormItem :label="$t('BasicProduct.funcBox.titleName.RW')" prop="readWrite" style="width: 400px">
                            <Select :placeholder="$t('selectPlaceholder')" transfer  class="input-div" v-model="formData.readWrite" clearable :disabled="isGener">
                               <Option v-for="item in selectObj.RWlist" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>
           
           
                        <FormItem :label="$t('BasicProduct.funcBox.titleName.UIcontroller')" prop="taskUiCode" style="width: 400px">
                          <Select :placeholder="$t('selectPlaceholder')" transfer  filterable class="input-div" v-model="formData.taskUiCode" clearable :disabled="isGener">
                               <Option v-for="item in selectObj.tackModuleList" :value="item.uiCode+''" :key="item.id">{{item.description}}</Option>
                           </Select>
                       </FormItem>
                         <FormItem :label="$t('BasicProduct.funcBox.titleName.SenseAction')" prop="senseAction" style="width: 400px">
                           <Select :placeholder="$t('selectPlaceholder')" transfer  class="input-div" v-model="formData.senseAction" clearable  :disabled="isGener">
                               <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>
                     
                        <FormItem :label="$t('BasicProduct.funcBox.titleName.conditionalControl')" prop="conUiCode" style="width: 400px">
                            <Select :placeholder="$t('selectPlaceholder')"  filterable class="input-div" v-model="formData.conUiCode" clearable transfer :disabled="isGener">
                               <Option v-for="item in selectObj.conditionModuleList" :value="item.uiCode+''" :key="item.id">{{item.description}}</Option>
                           </Select>
                       </FormItem>
                         <FormItem :label="$t('BasicProduct.funcBox.titleName.SenseCondition')" prop="senseCondition" style="width: 400px">
                           <Select :placeholder="$t('selectPlaceholder')" transfer   class="input-div" v-model="formData.senseCondition" clearable  :disabled="isGener">
                               <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>

                        <FormItem :label="$t('BasicProduct.funcBox.titleName.Musted')" prop="required" style="width: 400px" v-if="0">
                           <Select :placeholder="$t('selectPlaceholder')" transfer   class="input-div" v-model="formData.required" clearable  :disabled="isGener">
                               <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>
                  
                     
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.UpdateAsOffline')" prop="offlineOperation" style="width: 400px">
                           <Select :placeholder="$t('selectPlaceholder')"  transfer  class="input-div" v-model="formData.offlineOperation" clearable :disabled="isGener">
                               <Option v-for="item in selectObj.requiredList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>
           
                          <FormItem :label="$t('BasicProduct.funcBox.titleName.SenseOperation')" prop="conditionJudgment" style="width: 400px">
                           <Select :placeholder="$t('selectPlaceholder')"   class="input-div" v-model="formData.conditionJudgment" clearable   transfer :disabled="isGener">
                               <Option v-for="item in selectObj.conditionJudgmentList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                           </Select>
                       </FormItem>
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.Order')" prop="sortNumber" style="width: 400px">
                           <InputNumber :active-change="false" :min="1"  :step="1" :precision='0' v-model="formData.sortNumber" :placeholder="$t('inputPlaceholder')"  :disabled="isGener"></InputNumber>
                       </FormItem>
           
                        <FormItem :label="$t('BasicProduct.funcBox.titleName.Remark')" prop="remark" style="width: 400px">
                           <Input  maxlength="100" show-word-limit type="textarea" v-model.trim="formData.remark" :placeholder="$t('inputPlaceholder')"  :disabled="isGener"></Input>
                       </FormItem>
                  </TabPane>
                  <TabPane label="数据类型" name="tab2">
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.DataType')" prop="formatType" style="width: 500px;" class="dataItem">
                           <div class="flexBC">
                               <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.formatType" @on-select="setSelectVal($event,'formatType')"  :disabled="(isGener)?true:false">
                                   <Option v-for="item in formatTypeList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                               </Select>
                           </div>
                       </FormItem>
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.TypeDiscription')" prop="formatContent"  :class="formData.formatType!=13?'ivu-form-item-required dataItem':'dataItem' "  style="width: 500px">
                          
                           <!-- {{ formData.formatContent }} -->
                           <div v-if="formData.formatType==1 || formData.formatType==7 || formData.formatType==14 || formData.formatType==15 || formData.formatType==16">
                               <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                       <div class='paramsContainer' style="width:220px">
                                         
                                           <div class='itemContainer one-txt-cut' v-if='item.time && formData.formatType==16'>
                                               <span>{{$t('BasicProduct.funcBox.titleName.time')}}：</span>
                                               {{timeList[item.time]}}
                                           </div>
                                           <div class='itemContainer one-txt-cut' v-else>
                                               <span>{{$t('BasicProduct.funcBox.titleName.ValueRange')}}：</span>
                                             {{item.Min}}~{{item.Max}}
                                           </div>
                                       </div>
                                       <div class='operate'>
                                           <div class='operating' >
                                               <a @click="editTypeDiscription(item,index)">{{isGener?$t('detail'):$t('edit')}}</a>
                                               <!-- <a @click="delTypeDiscription(item,index)" :disabled="isGener">{{$t('delete')}}</a> -->
                                           </div>
                                       </div>
                               </div>
                           </div>
                           
                       
                           <div v-else-if="formData.formatType==12 || formData.formatType==6">

                               <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                   <div class='paramsContainer' style="width:220px">
                                       <div class='itemContainer one-txt-cut'>
                                           <span>{{$t('BasicProduct.funcBox.titleName.time')}}：</span>
                                           {{timeList[item.time]}}
                                       </div>
                                   </div>
                                   <div class='operate'>
                                       <div class='operating'>
                                           <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                       </div>
                                   </div>
                               </div>
                           </div>
       
                           <div v-else-if="this.formData.formatType==8 || this.formData.formatType==2 || this.formData.formatType==9 || this.formData.formatType==3">
                               <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                   <div class='paramsContainer' style="width:220px">
                                       <div class='itemContainer one-txt-cut'>
                                           <span>{{$t('BasicProduct.funcBox.titleName.LanguageKey')}}：</span>
                                         {{item[0] ?item[0].LanguageKey:""}}
                                       </div>
                                   </div>
                                   <div class='operate'>
                                       <div class='operating'>
                                           <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                         
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div v-else-if="this.formData.formatType==11">
                               <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                   <div class='paramsContainer' style="width:220px">
                                       <div class='itemContainer one-txt-cut'>
                                           <span>{{$t('BasicProduct.funcBox.titleName.LanguageKey')}}：</span>
                                           {{item[0] ?item[0].LanguageKey:""}}
                                       </div>
                                   </div>
                                   <div class='operate'>
                                       <div class='operating' >
                                           <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                           <!-- <a @click="delTypeDiscription(item,index)" :disabled="isGener">{{$t('delete')}}</a> -->
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <!-- struct结构体 -->
                           <div v-else-if="this.formData.formatType==13">
                               <div style="max-height:200px;overflow-y:auto">
                                   <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                       <div class='paramsContainer' style="width:220px">
                                           <div class='itemContainer one-txt-cut'>
                                               <span>{{formatTypeObj[item.formatType]}}：</span>
                                             {{item.LanguageKey}}
                                           </div>
                                       </div>
                                       <div class='operate'>
                                           <div class='operating' >
                                               <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                               <a @click="delTypeDiscription(item,index)" :disabled="isGener">{{$t('delete')}}</a>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div type="text" class="IndentyNameTextG" :class="[formData.formatType?'IndentyNameText':'',isGener?'operatingNo':'']"  @click="showIndentyName('formatContent')">
                                  {{formData.formatType?'++ '+$t('BasicProduct.addParams'):$t('BasicProduct.funcBox.TypeDiscriptionPlaceholder')}}
                               </div>
                           </div>
                           <!-- array数组 -->
                           <div v-else-if="this.formData.formatType==17">
                               <div class="flexBC" style="margin-bottom:10px" v-for="(item,index) in formData.formatContent" :key="index">
                                   <div class='paramsContainer' style="width:220px">
                                       <div class='itemContainer one-txt-cut'>
                                           <span>{{$t('BasicProduct.funcBox.titleName.ElementType')}}：</span>
                                         {{formatTypeObj[item.elementType]}}
                                       </div>
                                   </div>
                                   <div class='operate'>
                                       <div class='operating' >
                                           <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                           <!-- <a @click="delTypeDiscription(item,index)" :disabled="isGener">{{$t('delete')}}</a> -->
                                       </div>
                                   </div>
                               </div>
                           
                           </div>
               
               
                           <div v-if='formData.formatType !=4 && formData.formatType!= 10 && formData.formatType!= 13 &&  !((formData.formatType !=4 && formData.formatType !=10) && formData.formatContent.length==1)' type="text" class="IndentyNameTextG" 
                           :class="[formData.formatType?'IndentyNameText':'',isGener?'operatingNo':'']"  :title="formData.formatContentZh?formData.formatContentZh:''" @click="showIndentyName('formatContent')">
                              {{formData.formatType?'+ '+$t('BasicProduct.addParams'):$t('BasicProduct.funcBox.TypeDiscriptionPlaceholder')}}
                           </div>
                           
                           <Input v-if='formData.formatType==4' type="number" v-model.trim="formData.formatContentZh" :placeholder="$t('productManage.functionModel.inputPlaceholder.string')"  :disabled="isGener"></Input>
                           <Input v-if='formData.formatType==10 ' type="number" v-model.trim="formData.formatContentZh" :placeholder="$t('productManage.functionModel.inputPlaceholder.hexstring')"  :disabled="isGener"></Input>
                       
            
                           
                       </FormItem>
                       <FormItem :label="$t('BasicProduct.funcBox.titleName.Default')" prop="defaultValue" style="width: 500px" class="dataItem">
                           <Input :type="(formData.formatType==13 || formData.formatType==17 )?'textarea':'text'" :rows="4" v-model.trim="formData.defaultValue" :placeholder="$t('inputPlaceholder')"></Input>
                       </FormItem>
                       <!-- <div v-if='type==2' class="changeBox">
                           <Checkbox v-model="formData.modifyModelSync" style="display: block;margin: 0px 0px 10px 140px">{{$t('BasicProduct.titleName.modifyModelSync')}}</Checkbox>
                           <Checkbox v-model="formData.modifyDeviceSync" style="display: block;margin: 0px 0px 10px 140px">{{$t('BasicProduct.titleName.modifyDeviceSync')}}</Checkbox>
                       </div>
                       <Checkbox v-model="formData.resetDeviceSync" style="display: block;margin: 0px 0px 10px 140px">{{$t('BasicProduct.funcBox.titleName.resetSync')}}</Checkbox> -->
                      <FormItem >
                          <Button :loading="disabled" :disabled="designImplTypeNum==-1 && type==2" type="primary" @click="subData('formData')" style="margin-right:30px">{{$t('save')}}</Button>
                          <Button :disabled="disabled"  @click="cancel">{{$t('cancel')}}</Button>
                      </FormItem>
                  </TabPane>
                  <!-- <TabPane label="参数源码"  name="tab3" v-if="formData.formatType==13 || (formData.formatType==17 && formData.formatContent[0] && formData.formatContent[0].elementType==13)"> -->
                  <!-- && editFormData.communicateProtocol==3 -->
                    <TabPane label="参数源码"  name="tab3" v-if="type==2 && (formData.formatType==1 || formData.formatType==15 || formData.formatType==16 || formData.formatType==2 || formData.formatType==3 || formData.formatType==6 || formData.formatType==13 || (formData.formatType==17 && formData.formatContent[0] && formData.formatContent[0].elementType==13))">

                      <Input type="textarea" :rows="20" v-model="paramsCode" :placeholder="$t('inputPlaceholder')"></Input>

                      <div class="flexCC">
                         <Button :loading="paramsCodeLoding" type="primary" @click="saveParams" style="margin-top:20px;">源码{{$t('save')}}</Button>
                      </div>
                  </TabPane>
              </Tabs>
           </Form>
       </Modal>

       <NumberType      :showSetModel.sync="IndentyNameBox.showSetModelType"   :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></NumberType>
       <TimeType        :showSetModel.sync="IndentyNameBox.showSetModelType"     :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></TimeType>
       <EnumerationType :showSetModel.sync="IndentyNameBox.showSetModelType"   :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></EnumerationType>
       <EnumerationBool :showSetModel.sync="IndentyNameBox.showSetModelType"  :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></EnumerationBool>
       <BitvalueType    :showSetModel.sync="IndentyNameBox.showSetModelType" :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn"></BitvalueType>
       <StructType      :showSetModel.sync="IndentyNameBox.showSetModelType"   :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn" :formatTypeList="formatTypeList"></StructType>
       <ArrayType       :showSetModel.sync="IndentyNameBox.showSetModelType"    :isGener="isGener" :pageId="pageId"  :type="IndentyNameBox.type" :DataType='formData.formatType' :editFormData="IndentyNameBox.editFormData" :fn="IndentyNameBox.callbackFn" :formatTypeList="formatTypeList"></ArrayType>
       
       <!-- 已发布，修改需要输入管理员密码 -->
       <AdminModel ref='verifyPwdRef' :showSetModel.sync="adminModelBox.showModel"  :editFormData="adminModelBox.editFormData" :fn="adminModelBox.callbackFn" :loading="adminModelBox.loading"></AdminModel>
       
       
    </div>
   </template>
   <script>
   /**
    * 新增功能页面
    * 弹框
    * @param showSetModel boolean 对话框开关 true false
    * @param fn function 回调函数
    * @param type Number 类型 1添加 2编辑
    * @param editFormData Object 编辑时的数据
    */
   import common from '@/common/common';
   import moment from 'moment';
   import { mapState,mapMutations } from 'vuex'
   import { Message } from 'iview'
   // import LanguageLey from './component/languageKey.vue'
   import NumberType from './component/numberType.vue'
   // import BooleanType from './component/boolType.vue'
   import TimeType from './component/timeType.vue'
   import EnumerationType from './component/enumerationType.vue'
   import BitvalueType from './component/bitvalueType.vue'
   import EnumerationBool from './component/enumerationBool.vue'
   import StructType from './component/structType.vue'
   import ArrayType from './component/arrayType.vue'
   import AdminModel from './componentOther/showAdminModel.vue';  
   import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
   import SearchSelectRecycle from '@/views/common/selectListRecycle.vue';  //20220415

       export default {
           props: {
               showSetModel: Boolean,
               fn:Function,
               type:Number,
               editFormData:Object,
               funType:String,
               keyType:Number,
               basicTypeId:Number|| String,
               designImplTypeNum:Number,//1.普通，2.hex,-1，通用，普通+hex
               pageId:Number,
               isGener:{
                   type:Boolean,
                   default:false
               },
               published:{
                   type:Boolean,
                   default:false
               }
           },
           name: "Model3",
           components: {
               // LanguageLey,
               NumberType,
               // BooleanType,
               TimeType,
               EnumerationType,
               BitvalueType,
               EnumerationBool,
               StructType,
               ArrayType,
               AdminModel,
            //    ImportParams,
               SearchSelectPage,
               SearchSelectRecycle
           },
           data() {
               return {   
                   pagesLangDictionaryListUrl: this.config.urlArray.pagesLangDictionaryList,//语言列表
                   disabled: false,//禁用确定按钮
                   title: this.$t('BasicProduct.funcBox.title'),//弹框标题
                   currentTab:'tab1',
                   formData: {//表单数据
                       // Order: '1',
                       keyId:'',
                       keyName:'',
                       keyNameLanguageKey:'',
                       descr:'',
                       descrLanguageKey:'',
                       // Value:'',
                       defaultValue:'',
                       hexValueBytes:'',
                       readWrite:'',
                       required:'1',
                       remark:'',
                       sortNumber:0,
                       // DeviceAction:'',
                       // DeviceInterface:'',
                       taskUiCode:'',
                       conUiCode:'',
                       formatType:'',
                       formatContent:[],
                       formatContentZh:'',
                       // unitType:'',
                       // VIP:'',
                       // VIPcost:'',
                       senseCondition:'',
                       senseAction:'',
                       conditionJudgment:'',
                       offlineOperation:'',
                       chooseToUse:true,
                       // modifyModelSync:false,
                       // modifyDeviceSync:false,
                       // resetDeviceSync:false,
                       propertyId:'',//指令模板的唯一id。这个创建的时候不用送（我生成的），修改的时候和之前一样，带过来就好
                       identifier:'',//字段identifier是hyeco实现方式的指令标识，在创建lora指令的时候可以不用管他
                   }, 
                   IndentyNameBox:{
                       // showSetModel:false,
                       showSetModelType:false,
                       editFormData:{},
                       initdata:{},
                       key:{key1:'',key2:''},
                       propName:'',
                       type:1,
                       callbackFn:(e)=>{}
                   },
                   formatTypeList:[],
                   wordList:[],
                   wordListLoading:false,
                   pageID:'',
                   adminModelBox:{
                       showModel:false,
                       callbackFn:()=>{}, //弹框的回调函数
                       editFormData:{},//编辑时传入的现有数据
                       loading:false
                   },
                   paramsCode:"",
                   paramsCodeLoding:false
                   // formatTypeObj: {'1':'double','2':'enum','3':'bool','4':'text', '6':'date',
                   // '7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue',
                   // '12':'Hex Datetime','13':'struct','14':'Hex SNumerical','15':'float','16':'int32','17':'array'}
               }
           },
           computed:{
               ...mapState(['local','selectId','formatTypeObj','wordListAll','wordListByPageId','pageIdStore']),
               selectObj(){
                   return {
                       formatTypeList1:[
                           {id:16,val:'int32(整数型)'},
                           {id:15,val:'float(单精度浮点型)'},
                           {id: 1,val:'double(双精度浮点型)'},
                           {id: 2,val:'enum(枚举型)'},
                           {id: 3,val:'bool(布尔型)'},
                           {id: 4,val:'text(字符串)'},
                           // {id: 5,val:'Bitvalue'},
                           {id: 6,val:'date(时间型)'},
                           {id:13,val:'struct(结构体)'},
                           {id:17,val:'array(数组)'},
                       ],
                       formatTypeList2:[
                           {id: 7,val:'Hex Numerical'},
                           {id: 14,val:'Hex SNumerical'},//数值型，16进制，有符号
                           {id: 8,val:'Hex Enumeration'},
                           {id: 9,val:'Hex Boolean'},
                           {id: 10,val:'Hex String'},
                           {id: 11,val:'Hex Bitvalue'},
                           {id: 12,val:'Hex Datetime'},
                       ],
                       RWlist:[
                           {id: 1,val:this.$t('selectList.RWlist.RW')},
                           {id: 2,val:this.$t('selectList.RWlist.R')},
                       ],
                       requiredList:[
                           {id: 1,val:this.$t('selectList.MustedList.true')},
                           {id: 2,val:this.$t('selectList.MustedList.false')},
                       ],
                       conditionJudgmentList:[
                           {id: 1,val:">; = ;<"},
                           {id: 2,val:"="},
                           {id: 0,val:"None"},
                       ],
                       tackModuleList:[],
                       conditionModuleList:[]
    
                   }
               },
               timeList(){
                    return {
                        '1': this.$t('selectList.timeUnit.msceond'),
                        '2': this.$t('selectList.timeUnit.second'),
                        '3': this.$t('selectList.timeUnit.minute'),
                        '4': this.$t('selectList.timeUnit.hour'),
                        '0x01': this.$t('selectList.timeUnit.msceond'),
                        '0x02': this.$t('selectList.timeUnit.second'),
                        '0x03': this.$t('selectList.timeUnit.minute'),
                        '0x04': this.$t('selectList.timeUnit.hour'),
                    }
               },
               ruleCustom(){
                    return {//验证
                       Order: [
                           {required: true, message: this.$t('required'),trigger: 'blur' },
                       ],
                       // keyId1: [
                       //     {required: true, message: this.$t('required'),trigger: 'blur' },
                       //     {pattern: /^0[xX][0-9a-fA-F]+/, message: this.$t('ruleCustom.16'), trigger:'blur'}
                       // ],
                       keyId: [
                           { validator: this.validateKeyId,trigger: 'blur' }
                       ],
                       keyNameLanguageKey: [
                           { required: true, message: this.$t('required'),trigger: 'change'  }
                       ],
                       // descrLanguageKey: [
                       //     { required: true, message: this.$t('required'),trigger: 'change'  }
                       // ],
                       // Value: [
                       //     {required: true, message: this.$t('required'),trigger: 'blur' },
                       // ],
                       defaultValue: [
                           {required: false, message: this.$t('required'),trigger: 'blur' },
                       ],
                       sortNumber: [
                           {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                       ],
                       // hexValueBytes: [
                       //     {required: true, message: this.$t('required'),trigger: 'blur' },
                       // ],
                       unitType: [
                           {required: true, message: this.$t('required'),trigger: 'blur' },
                       ],
                       remark: [
                           {required: true, message: this.$t('required'),trigger: 'blur' },
                       ],
                       readWrite: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       required: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       DeviceAction: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       DeviceInterface: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       // taskUiCode: [
                       //     {required: false, message: this.$t('required'),trigger: 'change' },
                       //     {pattern: /^\d+$/, message: this.$t('ruleCustom.non_negative_integer'), trigger:'blur'}
                       // ],
                       // conUiCode: [
                       //     {required: false, message: this.$t('required'),trigger: 'change' },
                       //     {pattern: /^\d+$/, message: this.$t('ruleCustom.non_negative_integer'), trigger:'blur'}
                       // ],
                       formatType: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       VIP: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       senseCondition: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       senseAction: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       conditionJudgment: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ],
                       offlineOperation: [
                           {required: true, message: this.$t('required'),trigger: 'change' },
                       ]
                   }
                } 
           },
           created(){
              this.pageID = this.pageId || this.pageIdStore || ''
              this.getModuleList()
           },
           mounted(){
              
           },
           methods: {
               // ...mapMutations(['setwordListByPageId','setWordList']),
               getModuleList(){//获取控件列表
                 this.axios.post(this.config.urlArray.getModuleList,{}).then((result) => {
                       common.ajaxMsg(result.data,false,()=>{
                           let resData = result.data.data
                           if (resData && resData.length) {
                               this.selectObj.tackModuleList = resData.filter(item => item.uiModuleType==2)
                               this.selectObj.conditionModuleList = resData.filter(item => item.uiModuleType==1)
                           }
       
                       });
                      
                   })
               },
               selectT(val){
                  this.formData['orderDate1'] = val
                  this.formData['orderDate'] = new Date(val).getTime()    
               },
               setSelectVal(e,key){//
                   this.formData[key] = e+''
                   this.formData.formatContent= []
                   this.formData.formatContentZh=''
                   this.paramsCode = ''

               },
               setSelectValNew(selItem,key){
                  if(selItem){
                        let obj = {
                           'wordId': selItem.id+'',
                           'LanguageKey': selItem.wordCode,
                           'CN': selItem.simpleChinese,
                           'EN': selItem.englishText,
                           'pageId_wordCode': this.pageID+'_'+selItem.wordCode+''
                       }
                       
                       this.formData[key] = JSON.stringify(obj);
                       this.formData[key+'LanguageKey'] = selItem.wordCode

                  }else{
                      this.clearSelectVal(key)
                  }
               },
               clearSelectVal(key){
                   this.formData[key] = ''
                   this.formData[key+'LanguageKey'] = ''
               },
               delTypeDiscription(item,index){//删除数据类型详细
                  this.formData.formatContent.splice(index,1)
               },
               editTypeDiscription(item,index){//编辑数据类型详细
                   //  console.log('this.formData.formatContent',this.formData.formatContent)
                   //  console.log('itemitemitem',item)
                    console.log('编辑数据类型详细,editTypeDiscription')
                    this.IndentyNameBox.type = 2
                    this.hideModel()
                    
                    let typeObj0 = {'2':'Enumeration','8':'HexEnumeration','11':'Bitvalue','9':'HexBoolean','3':'Boolean'}
                    let formatType = this.formData.formatType+''
                    this.IndentyNameBox.editFormData = {IndentyName:item,allArr:this.formData.formatContent}
                    if(typeObj0[formatType]) this.addStatus()

                    console.log('this.IndentyNameBox.editFormDatathis.IndentyNameBox.editFormData',this.IndentyNameBox.editFormData)
                    
                     this.showTypeModel()
                     this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                       //重新载入,保存数据类型详细
                       console.log('editarr',arr)
                       this.hideModel()
                       this.formData.formatContent[index] = typeObj0[formatType]? [...arr]:{...arr}


                       if(formatType==13 || formatType==17){//struct 或者 array类型
                          this.paramsCode = (common.deepClone(arr)).formatContent
                       }
                               // formatTypeObj: {'1':'double','2':'enum','3':'bool','4':'text', '6':'date',
                                 // '7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue',
                                 // '12':'Hex Datetime','13':'struct','14':'Hex SNumerical','15':'float','16':'int32','17':'array'}
                       if(formatType==1 || formatType==15 || formatType==16 || formatType==2 || formatType==3 || formatType==6){//int32
                          this.paramsCode = JSON.stringify(common.deepClone(arr))
                       }

                    
                   }
               },
               saveParams(){//源码保存
                  let paramsCodeArr = []
                  console.log('this.paramsCode',this.paramsCode)
                  try {
                    paramsCodeArr = JSON.parse(this.paramsCode)
                  } catch (error) {
                    Message.error('请输入json字符串')
                    return
                  }

                  this.paramsCodeLoding = true

                  let formatType = this.formData.formatType
                 if(formatType==13){
                     this.formData.formatContent = common.deepClone(paramsCodeArr)
                     console.log('this.formData.formatContent',this.formData.formatContent)
                }

                // console.log('this.formData.formatTypethis.formData.formatType',this.formData.formatType)
                // console.log('this.formData.formatContent[0].elementType',this.formData.formatContent[0].elementType)
                   
                if(formatType==17 && this.formData.formatContent[0] && this.formData.formatContent[0].elementType==13){
                   this.formData.formatContent = common.deepClone([
                     {
                         elementType: "13",
                         formatContent: common.deepClone(paramsCodeArr)
                     }
                   ])
                }

                if(formatType==1 || formatType==15 || formatType==16 || formatType==6 ||formatType==2 || formatType==3){
                    this.formData.formatContent = common.deepClone([paramsCodeArr])
                }

                // if(formatType==2 || formatType==3){
                //     this.formData.formatContent = common.deepClone(paramsCodeArr)
                // }




                Message.success('源码已保存，请查看参数描述')
                this.paramsCodeLoding = false

                //   console.log('paramsCodeArrparamsCodeArrparamsCodeArr',paramsCodeArr)
                //   console.log('paramsCodeArrparamsCodeArrparamsCodeArr',this.formData.formatContent)
               },
  
               openOrClose(value) {
                   if(value === true) {
                       this.title = this.type == 1?this.$t('BasicProduct.funcBox.title')+this.funType:this.$t('BasicProduct.funcBox.title')+this.funType
                       if(this.type == 1){

                           this.$refs.keyNameRef.getData()
                           this.$refs.descrRef.getData()
                       }


                       if(this.designImplTypeNum==1 || this.funType.indexOf('0x08')>-1){
                           this.formatTypeList = this.selectObj.formatTypeList1
                       }else if(this.designImplTypeNum==-1){
                           this.formatTypeList = [...this.selectObj.formatTypeList2,...this.selectObj.formatTypeList1]
                       }else{
                           this.formatTypeList = this.selectObj.formatTypeList2
                       }
                       if(this.type == 2){//编辑表单时，给表单赋值
                           // console.log('this.editFormData',this.editFormData)
                           let hexArr = [7,8,9,10,11,12,14]
                           let keyId = hexArr.indexOf(this.editFormData.formatType*1)>-1?common.toHex(this.editFormData.keyId*1):this.editFormData.keyId
                           this.formData.keyId= keyId+''

                           try {
                               let keyNameObj = JSON.parse(this.editFormData.keyName)
                               this.formData.keyNameLanguageKey = keyNameObj.LanguageKey
                               this.$refs.keyNameRef.setDefVal({
                                  id:keyNameObj.wordId,
                                  wordCode: keyNameObj.LanguageKey
                                })

                           } catch (error) {
                               this.formData.keyNameLanguageKey = ""
                               this.$refs.keyNameRef.clearVal()
                               this.$refs.keyNameRef.getData()
                           }

                           if(this.editFormData.descr){
                               try {
                                   let descrObj = JSON.parse(this.editFormData.descr)
                                   this.formData.descrLanguageKey = descrObj.LanguageKey
                                   this.$refs.descrRef.setDefVal({
                                      id:descrObj.wordId,
                                      wordCode: descrObj.LanguageKey
                                    })
    
                               } catch (error) {
                                   this.formData.descrLanguageKey = ""
                                   this.$refs.descrRef.clearVal()
                               }
                           }else{
                               this.$refs.descrRef.getData()
                           }
                           this.formData.keyName = this.editFormData.keyName
                           this.formData.descr = this.editFormData.descr
          
                           this.formData.defaultValue = (hexArr.indexOf(this.editFormData.formatType*1)>-1 && this.editFormData.defaultValue)?'0x'+ this.editFormData.defaultValue:this.editFormData.defaultValue
                           this.formData.hexValueBytes=(this.editFormData.hexValueBytes || this.editFormData.hexValueBytes===0)?this.editFormData.hexValueBytes +"":''
                           
                           
                           this.formData.readWrite=this.editFormData.readWrite+''
                           this.formData.required=this.editFormData.required?'1':'2'
                           this.formData.formatType=this.editFormData.formatType+''
                           
                           this.formData.senseCondition=this.editFormData.senseCondition?'1':'2'
                           this.formData.senseAction=this.editFormData.senseAction?'1':'2'
                           this.formData.conditionJudgment=(this.editFormData.conditionJudgment || this.editFormData.conditionJudgment===0)?this.editFormData.conditionJudgment+'':''
                           this.formData.offlineOperation=this.editFormData.offlineOperation?'1':'2'
                           this.formData.chooseToUse=this.editFormData.chooseToUse
                           this.formData.remark=this.editFormData.remark
                           this.formData.sortNumber=this.editFormData.sortNumber*1
                           this.formData.propertyId=this.editFormData.propertyId
                           this.formData.taskUiCode = (this.editFormData.taskUiCode || this.editFormData.taskUiCode==0) ?this.editFormData.taskUiCode +'':(this.editFormData.uiCode?this.editFormData.uiCode+'': '') 
                           this.formData.conUiCode = (this.editFormData.conUiCode || this.editFormData.conUiCode==0) ?this.editFormData.conUiCode +'':''
                           this.formData.identifier = this.editFormData.identifier || ''
                           
                           if(!this.editFormData.formatContent) return
                           let arr = ['2','3','8','9','11']
                           let formatContentJson = this.editFormData.formatContent
                           try {
                               formatContentJson = JSON.parse(this.editFormData.formatContent)

                               console.log('formatContentJsonformatContentJson',formatContentJson)
                            //    console.log(' formatContentJson[0]', formatContentJson[0])
                                let commonKey = ['formatType','LanguageKey','keyId','pageId_wordCode','Name-CN','Name-EN']
                                let keyObj = {
                                    "3":[...commonKey,'false LanguageKey','true LanguageKey','false pageId_wordCode','true pageId_wordCode','false Name-CN','false Name-EN','true Name-CN','true Name-EN'],
                                    "4":[...commonKey,'Bytes'],
                                    "6":[...commonKey,'time','formate','maxTime','minTime'],
                                    "1":[...commonKey,'Min','Max','Unit LanguageKey','Unit pageId_wordCode','Decimals','Step','Unit Name-CN','Unit Name-EN'],
                                    "15":[...commonKey,'Min','Max','Unit LanguageKey','Unit pageId_wordCode','Decimals','Step','Unit Name-CN','Unit Name-EN'],
                                    "16":[...commonKey,'Min','Max','Unit LanguageKey','Unit pageId_wordCode','Decimals','Step','Unit Name-CN','Unit Name-EN'],
                                    // "16":[...commonKey,'Min','Max','Unit LanguageKey','Unit pageId_wordCode','Decimals','Step','Unit Name-CN','Unit Name-EN','time','formate','max','min'],
                                    "2":[...commonKey,'enumItems'],
                                }

                                
      
                                if(this.formData.formatType==13 || (this.formData.formatType==17 && formatContentJson[0] && formatContentJson[0].elementType==13)){//struct 或者 array类型的类型是struct
                                    let formatContentArr= this.formData.formatType==13?common.deepClone(formatContentJson):(common.deepClone(formatContentJson[0].formatContent))
                                    
                                    let paramsCodeArr = []

                                    // console.log(' this.formData.formatType', this.formData.formatType)
                                    // console.log(' common.deepClone(formatContentJson[0].arrayItems', common.deepClone(formatContentJson[0].arrayItems))

                                    // console.log('formatContentArr',formatContentArr)

                                    



                                    for(let i=0;i<formatContentArr.length;i++){
                                        let formatType = formatContentArr[i].formatType
                                        if(keyObj.hasOwnProperty(formatType)){//布尔
                                            let obj = {}
                                             keyObj[formatType].forEach(itemKey=>{
                                                obj[itemKey] = formatContentArr[i][itemKey] || ''
                                             })

                                             if(formatType==2){
                                                let enumItemsArr = []
                                                formatContentArr[i]['enumItems'].map(enumItem=>{
                                                    enumItemsArr.push({
                                                        "Code":enumItem.Code,
                                                        "LanguageKey":enumItem.LanguageKey,
                                                        "pageId_wordCode":enumItem.pageId_wordCode,
                                                        "Name-CN":enumItem["Name-CN"],
                                                        "Name-EN":enumItem["Name-EN"],
                                                        // "wordId":enumItem.wordId+"" || '',
                                                    }) 
                                                })
                                                obj['enumItems'] = enumItemsArr
                                             }
                                          
                                            paramsCodeArr.push(obj)
                                        }

                                        if(this.formData.formatType==13 && formatType==17 ){//strcut 选了array 
                                            let dataArr = {}

                                            if(formatContentArr[i].elementType==13){//array选了struct
                                                // console.log('formatContentArr[i].arrayItems',formatContentArr[i].arrayItems)
                                                for(let j = 0;j<formatContentArr[i].arrayItems.length;j++){
                                                    if(formatContentArr[i].arrayItems[j].arrayItems){
                                                        delete formatContentArr[i].arrayItems[j].arrayItems
                                                    }
                                                }
                                                dataArr = 
                                                   {   
                                                       "formatType":"17",
                                                       "elementType":"13",
                                                       "LanguageKey":formatContentArr[i].LanguageKey,
                                                       "keyId":formatContentArr[i].keyId,
                                                       "pageId_wordCode":formatContentArr[i].pageId_wordCode,
                                                       "Name-CN":formatContentArr[i]["Name-CN"],
                                                       "Name-EN":formatContentArr[i]["Name-EN"],
                                                       "wordId":formatContentArr[i].wordId,
                                                       "arrayItems":_.cloneDeep(formatContentArr[i].arrayItems)
                                                   }
                                            }else{//array选了其他
                                                dataArr = 
                                                   {   
                                                       "formatType":"17",
                                                       "elementType":formatContentArr[i].elementType,
                                                       "LanguageKey":formatContentArr[i].LanguageKey,
                                                       "keyId":formatContentArr[i].keyId,
                                                       "pageId_wordCode":formatContentArr[i].pageId_wordCode,
                                                       "Name-CN":formatContentArr[i]["Name-CN"],
                                                       "Name-EN":formatContentArr[i]["Name-EN"],
                                                       "wordId":formatContentArr[i].wordId
                                                   }
                                            }

                                            paramsCodeArr.push(dataArr)
                                            
                                        }
                             
                                       
                                    }

                                    
                                    
                                    this.paramsCode =JSON.stringify((_.cloneDeep(paramsCodeArr))) 

                                    // console.log('paramsCodeArr',(common.deepClone(paramsCodeArr)))

                                    
                                    // console.log('this.paramsCode',this.paramsCode)
                                    // console.log('this.formData.formatContent',this.formData.formatContent)
                                }

                                  // formatTypeObj: {'1':'double','2':'enum','3':'bool','4':'text', '6':'date',
                                 // '7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue',
                                 // '12':'Hex Datetime','13':'struct','14':'Hex SNumerical','15':'float','16':'int32','17':'array'}
                                // 3:数组 ，4：数字 2：数组
                                let keyObjOne = {
                                    "2":['Code','LanguageKey','pageId_wordCode','Name-CN','Name-EN'],
                                    "3":['Code','LanguageKey','pageId_wordCode','Name-CN','Name-EN'],
                                    // "4":['Bytes'],
                                    "6":['time','formate','max','min'],
                                    "1":['LanguageKey','pageId_wordCode','Min','Max','Decimals','Step','Unit-CN','Unit-EN'],
                                    "15":['LanguageKey','pageId_wordCode','Min','Max','Decimals','Step','Decimals','Step','Unit-CN','Unit-EN'],
                                    "16":['LanguageKey','pageId_wordCode','Min','Max','Decimals','Step','Decimals','Step','Unit-CN','Unit-EN','time','formate','max','min'],
                                }

                                if(keyObjOne.hasOwnProperty(this.formData.formatType)){
                                        let formatContentArr= common.deepClone([...JSON.parse(this.editFormData.formatContent)])
                                        let paramsCodeArr = []
                                        for(let i=0;i<formatContentArr.length;i++){
                                            let obj = {}
                                            keyObjOne[this.formData.formatType].forEach(itemKey=>{
                                                obj[itemKey] = formatContentArr[i][itemKey] || ''
                                             })

                                            //  console.log('objobjobj',obj)

                                             if(this.formData.formatType==16){
                                                if(formatContentArr[i].time){
                                                    delete obj['Min']
                                                    delete obj['Max']
                                                    delete obj['Step']
                                                    delete obj['Decimals']
                                                    delete obj['Decimals']
                                                    delete obj['Unit-CN']
                                                    delete obj['Unit-EN']
                                                    delete obj['LanguageKey']
                                                    delete obj['pageId_wordCode']
                                                }
                                                if(formatContentArr[i]["LanguageKey"]){
                                                    delete obj['time']
                                                    delete obj['formate']
                                                    delete obj['max']
                                                    delete obj['min']
                                                }
                                             }

                                             paramsCodeArr.push(obj)
                                           
                                        }
                                    if(this.formData.formatType==1 || this.formData.formatType==15 || this.formData.formatType==16 || this.formData.formatType==6){
                                    
                                        this.paramsCode =JSON.stringify((common.deepClone(paramsCodeArr[0])))
                                    }else if(this.formData.formatType==2 || this.formData.formatType==3){
                                        this.paramsCode =JSON.stringify((common.deepClone(paramsCodeArr)))
                                    }
   
                                }

                           } catch (u) {console.log('u',u)}
                           // console.log('this.editFormData',this.editFormData)
                           
                           let formatContentArr = (arr.includes(this.formData.formatType))?[formatContentJson]:formatContentJson
                           this.formData.formatContent=formatContentArr
                           this.formData.formatContentZh=this.editFormData.formatContent
                       }       
                   } else { //关闭弹框后要做的处理
                       this.resetForm();//重置表单
                       document.body.style.overflow = 'visible';
                       this.$refs.keyNameRef.clearVal()
                       this.$refs.descrRef.clearVal()
                   }
               },
               hideModel(){//所有子组件弹窗关闭
                   this.IndentyNameBox.showSetModelType = false
               },
               showTypeModel(){ //对应Type弹框-开
                   this.IndentyNameBox.showSetModelType = true
               },
               addStatus(){
                    let arr = [...this.formData.formatContent]
                    arr.map((item,index)=>{ 
                        item.map((items,indexs)=>{
                              items.index = indexs+1
                              items.status = 1
                              return items
                        })
                     
                       return item
                    }) 
               },
               delStatus(){
                   this.formData.formatContent = this.formData.formatContent.map(item=>{
                       if(item.index) delete item.index
                       if(item.status) delete item.status
                       return item
                   })
               },
               showIndentyName(typeName){//对应Type表单项
                    if(this.isGener){
                        return
                    }
                   //  let formatTypeList1 = {'1':'Numerical','2':'Enumeration','3':'Boolean','4':'String', '6':'Date time','7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue','12':'Hex Datetime'}
                    
                    this.hideModel()
    
                   if(typeName=='formatContent'){ //数据类型详细定义
                       this.IndentyNameBox.type = 1
                       this.showTypeModel()
                       this.IndentyNameBox.editFormData = {IndentyName:[],allArr:this.formData.formatContent}
                     
                   }
                   this.IndentyNameBox.callbackFn = (arr,text) => {//回调处理
                       // console.log('addarr',arr)
                       //重新载入
                       this.hideModel()
                       if(typeName=='formatContent'){
                           this.formData.formatContent.push(arr)
                           this.delStatus()

                        //    let formatType = this.formData.formatType

                        //    if(formatType==13 || formatType==17){//struct 或者 array类型
                        //       this.paramsCode = (common.deepClone(arr)).formatContent
                        //    }
                        //    if(formatType==1 || formatType==15 || formatType==16 || formatType==2 || formatType==3 || formatType==6){//int32
                        //       this.paramsCode = JSON.stringify(common.deepClone(this.formData.formatContent[0]))
                        //    }
                           console.log('this.formData.formatContent',this.formData.formatContent)
                       }
                   }
               },
               validateKeyId(rule, value, callback){
                   
                   if(this.editFormData.communicateProtocol!=3){//字段identifier是hyeco实现方式的指令标识，在创建lora指令的时候可以不用管他
                       let pattern = /^0[xX][0-9a-fA-F]+/
                       let pattern1 = /^[1-9]\d*$/
       
                       let hexArr = [7,8,9,10,11,12,14]
                     
                       if (value === '') {
                           callback(new Error(this.$t('required')));
                       } else {
                           // console.log(pattern.test(value),this.formData.formatType,this.designImplTypeNum)
                            if(!pattern.test(value) && (hexArr.indexOf(this.formData.formatType*1)>-1 || (this.designImplTypeNum==2 && this.funType.indexOf('0x08')<0)) ) {
                               //  console.log(1111)
                                callback(new Error(this.$t('ruleCustom.16')));
                            }else if(pattern.test(value) && Number(value).toString(10)>63){
                               //  console.log(2222)
                                callback(new Error(this.$t('ruleCustom.0x3f')));
                            }else if(pattern.test(value) && Number(value).toString(10)<=63){
                               //  console.log(2222)
                                callback();
                            }else{
                                if(!pattern1.test(value)){
                                   //  console.log(23333)
                                   callback(new Error(this.$t('ruleCustom.positive_integer')));
                                }else{
                                   //  console.log(4444)
                                   callback();
                                }
                                
                            }
                       }
                   }else{
                       callback();
                   }
               },
               showAdminData(url,params) {  //发布后的基础型号修改需要输入管理员密码
            
                   this.adminModelBox.showModel = true
                   this.adminModelBox.callbackFn = (password) => {//回调处理
                       //重新载入
                       this.adminModelBox.loading = true;
                     
                       this.axios.post(url, {...params,password:password}).then((result) => {
                               
                           common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                               this.adminModelBox.loading = false;
                               this.$refs.verifyPwdRef.handleCancel()
                               setTimeout(() => {//滚动条问题
                                   this.cancel();
                                   this.fn()
                               }, 0);
                           },()=>{
                               this.disabled = false;
                               this.adminModelBox.loading = false;
                           })
                       }).catch((err) => {
                           this.disabled = false;
                           this.adminModelBox.loading = false;
                       });
                   }
               },
               subData(name) {//提交表单
                   console.log('this.formData.formatContentsubData',this.formData.formatContent)
                   console.log('this.formData',this.formData)
                   if(this.formData.formatContent.length<1 && !this.formData.formatContentZh && this.formData.formatType !=13){
                       this.$Message.error(this.$t('BasicProduct.funcBox.titleName.TypeDiscription')+this.$t("required"))
                       return
                   }


                  
            
                  
                   this.$refs[name].validate((valid) => {

                       if (valid) {
        
                       
                     
                           let formatContent = (this.formData.formatType==4 || this.formData.formatType== 10 )?this.formData.formatContentZh :''
                           // console.log('this.formData.formatContentZh',this.formData.formatContentZh)
                          
                          
                           let arr = ['2','3','8','9','11']
                           let formatContentArr =  (arr.indexOf(this.formData.formatType+'')>-1)?this.formData.formatContent[0]:this.formData.formatContent

                        //    console.log('formatContentArrformatContentArrformatContentArr',formatContentArr)
                         
                           let formatTypeHexArr = [7,8,9,10,11,12,14]
                           let keyId = formatTypeHexArr.includes(this.formData.formatType*1)? Number(this.formData.keyId).toString(10):this.formData.keyId*1


                           
                           let flag0x = this.selectObj.formatTypeList2.some((item)=>{
                               return item.id == this.formData.formatType
                           }) && (this.formData.defaultValue!==undefined && (this.formData.defaultValue.indexOf('0x')==0 || this.formData.defaultValue.indexOf('0X')==0))
                           
                           
                           console.log('flag0x',flag0x)


                           console.log('this.formData.keyName',this.formData)
       
                           let params = {
                               ...this.formData,
                               basicTypeId:this.basicTypeId,
                               keyType:this.keyType*1,
                               // keyName:JSON.stringify(this.formData.keyName),
                               keyName:this.formData.keyName,
                               required:this.formData.required==1?true:false,
                               senseCondition:this.formData.senseCondition==1?true:false,
                               senseAction:this.formData.senseAction==1?true:false,
                               offlineOperation:this.formData.offlineOperation==1?true:false,
                               formatContent:formatContent?formatContent : JSON.stringify(formatContentArr) ,
                               keyId:keyId,
                               hexValueBytes:this.formData.hexValueBytes*1,
                               readWrite:this.formData.readWrite*1,
                               formatType:this.formData.formatType*1,
                               conditionJudgment:this.formData.conditionJudgment*1,
                               taskUiCode:(this.formData.taskUiCode && this.formData.taskUiCode!='' && this.formData.taskUiCode!='undefined') ? this.formData.taskUiCode+"":null,
                               conUiCode:(this.formData.conUiCode &&  this.formData.conUiCode!='' && this.formData.taskUiCode!='undefined') ? this.formData.conUiCode+"":null,
                               defaultValue:flag0x?this.formData.defaultValue.slice(2):(this.formData.defaultValue===undefined?'':this.formData.defaultValue),
                               identifier:this.formData.identifier
                           }
                           if(this.type == 2){
                               params.id = this.editFormData.id
                           }
                           if(this.editFormData.communicateProtocol!=3){
                               delete params.identifier
                           }else{
                            // 吕伟平台没用keyId
                               delete params.keyType
                               delete params.keyId
                               delete params.hexValueBytes
                              
                           }
                  
                           // let arrU = [1,2,3,4,6,13,15,16,17]
                           // if(this.designImplTypeNum==1 || arrU.includes(params.formatType)){
                           //     delete params.hexValueBytes
                           //     // 暂时设置为0
                           //     params.hexValueBytes = 0
                           // }
                           
                           if(this.designImplTypeNum==1 || this.keyType==8){//1是普通 ,8是云端参数
                               // 暂时设置为0
                               params.hexValueBytes = 0
                           }
                       
                  
                           
                           if(this.type == 1){
                               delete params.chooseToUse
                               delete params.propertyId
                           }
                           // if(this.formData.formatType== 13){
                           //     delete params.formatContent
                           // }
                          
                            console.log('this.params',params)
                           //  return
                           //  console.log('this.formData',this.formData)
                           //  console.log('this.editFormData',this.editFormData)
                           let url = this.type==1?this.config.urlArray.createLoraKey:this.config.urlArray.setBasicKeys
                           
                        //    if(this.published){
                        //        this.showAdminData(url,params)
                             
                        //        return
                        //    }


                           this.disabled = true;
                           this.axios.post(url, params).then((result) => {
                               common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                   this.resetForm();//重置表单
                                   this.fn()
                               },()=>{
                                this.disabled = false
                                if(result.data.code == 14053){//需要输入密码才能操作
                                    this.showAdminData(url,params)
                                }
                            })
                               
                           }).catch((err) => {
                               this.disabled = false
                           });
                           
                       }
                   })
               },
               cancel() {//对话框关闭
                   this.$emit('update:showSetModel',false);
                   this.resetForm()
               },
               resetForm() {//重置表单
                   this.$refs.formData.resetFields();//重置表单
                   this.formData.keyNameZh = ''
                   this.formData.descrZh = ''
                   this.formData.formatContentZh = ''
                   this.formData.keyName = []
                   this.formData.formatContent = []
                   this.formData.chooseToUse = true
                   this.formData.sortNumber = 0
                   this.paramsCode="";
                   this.paramsCodeLoding=false
                   this.disabled = false;//恢复提交按钮为激活状态
                   this.currentTab = 'tab1'
               }
           }
       }
   </script>
   <style lang="less" scoped>
   .scroller{
       max-height:185px
   }
   /deep/ .vertical-center-modal{
       display: flex;
       align-items: center;
       justify-content: center;
       .ivu-modal{
           top: 0;
       }
      
   }
   /deep/ .ivu-input-number{
       width: 100% !important;
   }
   .IndentyNameTextG{
       padding: 0px 7px;
       font-size: 14px;
       // border: 1px solid #dcdee2;
       // border-radius: 4px;
       color: #C5C8CE;
       cursor: pointer;
       overflow: hidden;
   }
   .IndentyNameText{
       color: #0070cc;
       // border: 1px solid #fff;
   }
   .IndentyNameTextG1{
       padding: 0px 7px;
       font-size: 14px;
       border: 1px solid #dcdee2;
       border-radius: 4px;
       color: #C5C8CE;
       cursor: pointer;
       overflow: hidden;
   }
   .IndentyNameText1{
       color: #515a6e;
   }
   .IndentyNameTextGray{
       background-color: #f3f3f3;
       opacity: 1;
       cursor: not-allowed;
       color: #ccc;
   }
   .errorLine{
       border: 1px solid #ed4014;
   }
   /deep/ .ivu-form-inline .dataItem {
       display: block !important;
   }
   .paramsContainer {
       border: 1px solid #e1e2e5;
       background: #e3f2fd;
       padding:0 8px;
       display: flex;
       color: #9b9ea0;
       font-size: 12px;
       // height: 30px;
       // line-height: 30px;
       span {
           color: #73777a;
           margin-right: 4px;
       }
   }
   .operating {
       a {
           font-size: 12px;
           margin-left: 8px;
           margin-right: 0;
           color: rgb(0, 112, 204);
           &:nth-of-type(2) {
               padding-left: 8px;
               border-left: 1px solid #d8d8d8;
           }
       }
   }
   .operatingNo{
       cursor: not-allowed;
       color: #ccc;
       a {
           cursor: not-allowed;
           color: #ccc;
       }
   }
   /deep/ .ivu-form .ivu-form-item-label{
       width: 140px !important;
   }
   /deep/ .ivu-form-item-content {
       margin-left: 140px !important;
   }
   /deep/ .ivu-form .ivu-select-dropdown{
         max-width: 260px !important;
   }
   </style>
   